export default __webpack_public_path__ + "static/media/real-time.6563bfd7.svg";